import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { user, initActions, loginActions } from './user-reducers';
import { ui } from './ui-reducers';
import { approvedAccounts } from './approved-reducers';
import { periods, pickups } from './settings-reducers';

// BROWSER HISTORY

const createRootReducer = history => combineReducers({
    // USER

    user,
    initActions,
    loginActions,

    // UI

    ui,

    // APPROVED

    approvedAccounts,

    // SETTINGS

    periods,
    pickups,

    router: connectRouter(history),
});

export default createRootReducer;
